<template>
  <div
    class="statsmoves"
    :class="`statsmoves_${displayAs}`"
  >
    <ChartColumn
      v-for="(move, index) in items"
      :key="`${index}_${move.id}`"
      class="statsmoves_chart"
      :class="`chrtcol_${displayAs}`"
      :style="`
           color:var(${move.group.color});
            --radius:4px;
            --clr-back-chart: var(--chart-clr-back);
            --chart-value: ${move.value_percent_scaled * 100}%;
            `"
    >
      <template #label>
        <div class="statsmoves_name">
          <span
            class="mdi statsmoves_name_icon mr-2 line-height_1"
            :class="move.group.icon"
          ></span>
          <span
            class="text-nowrap truncate"
            :title="move.name"
            >{{ move.name }}</span
          >
        </div>
      </template>
      <template #after>
        <div class="statsmoves_value">
          {{ move.value ? move.value : '0' }}
        </div>
      </template>
    </ChartColumn>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import ChartColumn from '@/components/lib/ChartColumn'

export default {
  name: 'PracticeStatMovesChart',

  components: {
    ChartColumn,
  },
  mixins: [format_mix, float_mix],
  props: {
    items: Array,
    displayAs: { default: 'table' },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.statsmoves {
  --chart-clr-back: var(--clr-black-3);
  flex: 1;
  &_name,
  &_value {
    display: flex;
    align-items: center;
  }
  &_name {
    font-weight: 500;
    padding: 0 1rem 0 0;
    &_icon {
      font-size: 1.25rem;
    }
  }
  &_value {
    font-weight: 500;
    padding: 0 0 0 1rem;
  }
  &_table {
    display: table;
  }
  &_column {
    --gap: 0.5rem;
    // display: flex;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: auto;
    grid-auto-flow: column;

    grid-gap: var(--gap);
    .statsmoves_chart {
      min-width: 0;
      min-height: 0;
      overflow: hidden;
    }
    .statsmoves_name,
    .statsmoves_value {
      flex: 1;
      width: 100%;
      // justify-content: center;
    }
    .statsmoves_name {
      padding: 0 0 0.5rem 0;
      text-transform: uppercase;
      &_icon {
        font-size: 1.25rem;
      }
    }
    .statsmoves_value {
      padding: 0.25rem 0 0 0;
    }
  }
}
</style>
